import firebase from 'firebase/app'

export default {
  actions: {
    async login({dispatch, commit}, {email, password}) {
      
      try {
        await firebase.auth().signInWithEmailAndPassword(email, password)

      } catch (e) {
        commit('setError', e)
        //commit позволяет изменять стейт. мутатион называется сет еррор куда пеердаем ошибоку

        throw e
      }
    },
    async register({dispatch, commit}, {email, password, name}) {
      debugger
       // забрать из контекста метод dispatch
       //если сюда не передать метод коммит то коммит ниже работать не будет
      try {
        await firebase.auth().createUserWithEmailAndPassword(email, password)
        //это метод файерб чтобы создать пользователя
         // debugger
        const uid = await dispatch('getUid')
          // debugger
        //запускает актион гетюйди который возвр юайди пользователся
        //дальше идет запись в базе данных-апдейт нового пользователя
        await firebase.database().ref(`/users/${uid}/info`).set({
          //в таблицу инфо. залее вызываем метод сет куда передаем начальные значения
          bill: 10000,
          name
          //нейм передаем в регистр
        })
      } catch (e) {
        commit('setError', e)
        //commit позволяет изменять стейт. мутатион называется сет еррор куда пеердаем ошибоку

        throw e // чтобы продолжели эту ошибку
      }
    },
    getUid() {

      const user = firebase.auth().currentUser
       // debugger
      
      
      // console.log('user.uid = ' + user.uid)
      //обращ к ФБ к методу аус и забирает у него поле каррентюзер
      return user ? user.uid : null
      //если в поле юзер что либо есть возвр юзер юайди или нул если нет 8/4,50
    },
    async logout({commit}) {
      await firebase.auth().signOut()//метод файербейза очистки всех данных сайнаут
        commit('clearInfo')  //clearInfo это мутейтион а они вызываются через метод коммит а не диспатч
          //возвращает проми поэтому пишем авейт
        //когда делаем логаут мы чистим актион

    }							 
  }
}   